import { type Jurisdiction } from '@dec/shared';

import httpApiApplication from '@/app/http/httpApiApplication';

import {
  type CurrentAccountJurisdictionSummary,
  type CurrentAccountSummary,
  type CurrentAccountTaxpayerStats
} from '../models/CurrentAccount';

export const currentAccountService = {
  getAccount: async (accountId: string) => {
    const response = await httpApiApplication.get<CurrentAccountSummary>(
      `/current-account/accounts/${accountId}`
    );

    return response;
  },

  getAccountJurisdiction: async (accountId: string) => {
    const response = await httpApiApplication.get<CurrentAccountJurisdictionSummary>(
      `/current-account/accounts/jurisdiction/${accountId}`
    );

    return response;
  },

  getJurisdictions: async () => {
    const response = await httpApiApplication.get<Array<Jurisdiction>>(`/jurisdictions`);

    return response;
  },

  getTaxpayerStats: async (taxpayerId: string): Promise<Array<CurrentAccountTaxpayerStats>> => {
    const response = await httpApiApplication.get<Array<CurrentAccountTaxpayerStats>>(
      '/current-account/stats/' + taxpayerId
    );

    return response;
  }
};
